/**
 * 全局配置文件
 */
const IP = import.meta.env.VITE_APP_IP;
const VITE_APP_UPLOAD_IP = import.meta.env.VITE_APP_UPLOAD_IP;
const TENANT_ID = import.meta.env.VITE_APP_TENANT_ID
export default {
  title: '',
  logo: 'S',
  key: 'saber', //配置主键,目前用于存储
  indexTitle: 'EMP management system',
  clientId: 'saber3', // 客户端id
  clientSecret: 'saber3_secret', // 客户端密钥
  tenantMode: true, // 是否开启租户模式
  tenantId: TENANT_ID, // 管理组租户编号 有脏数据
  // tenantId: '722132', // 管理组租户编号
  captchaMode: true, // 是否开启验证码模式
  switchMode: false, // 是否开启部门切换模式
  lockPage: '/lock',
  tokenTime: 3000,
  tokenHeader: 'Blade-Auth',
  //http的status默认放行不才用统一处理的,
  statusWhiteList: [],
  //配置首页不可关闭
  setting: {
    showTopMenu: true, // 顶部菜单栏
    breadcrumb: true, // 面包屑导航 一般和顶部菜单栏
    showSideMenu: false, // 侧边菜单栏
    tag: false, // 导航标签，一般和侧边菜单同时打开
    sidebar: 'vertical',
    debug: false,
    collapse: false,
    search: false,
    lock: false,
    screenshot: true,
    fullscreen: false,
    theme: false,
    color: false,
    menu: true,
  },
  languages: { // 下拉框语言选择配置
    'zh-CN': ['en-US', 'id-ID', 'zh-CN', 'th-TH'], // 影响模型枚举排序
    'id-ID': ['en-US', 'id-ID'], // 影响模型枚举排序
    'th-TH': ['en-US', 'th-TH', 'zh-CN', 'id-ID'], // 影响模型枚举排序
    'en-US': ['en-US', 'id-ID', 'zh-CN', 'th-TH'], // 影响模型枚举排序
  },
  showBigPage: false, // 是否显示大屏页面 true显示 并且把firstPage的path改为大屏页面的path /dashboard id
  bigPageId: '1868589053790371842', // dashboard 大屏页面id
  firstPage: {
    name: '首页',
    // path: '/dashboard',
    // path: '/wel/index',
    path: '/energyManage/energyAnalysis',
  },
  sidebarPages: [ // 带侧边栏页面，隐藏默认面包屑导航
    '/energyManage/energyAnalysis',
    '/energyManage/environmentalAnalysis',
    '/energyManage/photovoltaicStation',
    '/energyManage/dataStastistics',
    '/gatewayManage/gatewayData',
    '/assemble/index',
    '/projectManage/projectEnergyItem',
    '/projectManage/projectList',
    '/system/user',
    '/billing/tenantManage',
    '/OMsystem/inspectStandar',
    '/OMsystem/maintainStandar',
    '/device/historyData',
    '/gatewayManage/deviceManage',
    '/system/dimensionConfig',
    '/authority/role',
    '/wel/index',
    '/billing/billDashboard',
  ],
  //配置菜单的属性
  menu: {
    iconDefault: 'icon-caidan',
    label: 'name',
    path: 'path',
    icon: 'source',
    children: 'children',
    query: 'query',
    href: 'path',
    meta: 'meta',
    i18nValue: 'i18nValue',
  },
  //oauth2配置
  oauth2: {
    // 是否开启注册功能
    registerMode: true,
    // 使用后端工程 @org.springblade.test.Sm2KeyGenerator 获取
    publicKey: '049fb3e1739c57837aa1f73720fc66de4cfd984cad3a3a6c47dc470aa64b8527424d80a83749a479106ea6192ae9b34cd8c674eb3c99e089bbe1b56942cbf74a91',
    // 第三方系统授权地址
    authUrl: `//${IP}:80/blade-auth/oauth/render`,
    // 单点登录系统认证(cloud端口为8100,boot端口为80)
    ssoUrl: `//${IP}:8100/oauth/authorize?client_id=saber3&response_type=code&redirect_uri=`,
    // 单点登录回调地址(服务的登录界面地址)
    redirectUri: `//${IP}:2888/login`,
  },
  websocketUrl: `ws://${IP}:6655/ws`, // websocket地址
  // imageBaseUrl: '//103.228.160.122:9000', // 图片上传存储的路径
  imageBaseUrl: `//${VITE_APP_UPLOAD_IP}:9000`, // 图片上传存储的路径
  //设计器配置
  design: {
    // 流程设计器类型(true->nutflow,false->flowable)
    designMode: true,
    // 流程设计器地址(flowable模式)
    designUrl: '//localhost:9999',
    // 报表设计器地址(cloud端口为8108,boot端口为80)
    reportUrl: '//localhost:8108/ureport',
  },
};
